import dataFetchingClient from '../../utils/DataFetchingClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { TreatmentsClient } from './experimentsUtils';
const GET_EXPERIMENTS = registerQuery({
  fieldName: 'experiments',
  args: [],
  fetcher() {
    return new Promise(resolve => {
      TreatmentsClient.get().resolve(treatments => {
        resolve(treatments);
      });
    });
  }
});
export const getExperiments = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_EXPERIMENTS
  });
};
export const useExperiments = () => {
  const {
    data: experiments,
    loading: experimentsLoading,
    error: experimentsError
  } = useQuery(GET_EXPERIMENTS);
  return {
    experiments,
    experimentsLoading,
    experimentsError
  };
};
export const useIsVariation = experiment => {
  const {
    experiments
  } = useExperiments();
  return experiments && experiments[experiment] && experiments[experiment].parameters.group === 'variation';
};